import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import CmsElement from 'Components/Utilities/CmsElement';
import {Loading} from 'Components/Partials';
import {RenderWYSIWYG} from 'Components/Form';
import MailLink from 'Components/Utilities/MailLink';

import {asset} from 'Services/BaseHelpers';
import {getRecordValue} from 'Services/CmsHelpers';
import {translation} from 'Services/TranslationHelpers';
import {User} from 'Services';

export default class Venues extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'venues';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var state
     */
    state = {
        working: true
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {working, records} = this.state;

        let data = null;

        if (!working && records.data !== null && records.data.length !== 0) {
            data = records.data;

            // Filter records to just this user's region.
            if (User?.data?.region) {
                data = data.filter(venue => {
                    let regions = getRecordValue(venue, 'regions');

                    if (!regions) {
                        return false;
                    }

                    return regions.includes(User.data.region);
                });
            }
        }

        return (
            <Authenticated title="Venues">
                <h1 className="canela-text text-5xl text-center">
                    Venue
                </h1>

                <div className="font-light mt-8">
                    <p className="text-center mb-12">
                        Please find your region specific venue information below.
                        <br/>
                        If you have any queries please contact the events team at <MailLink to="bootsevents@top-b.com" />
                    </p>

                    {working && <Loading />}

                    <p className="font-bold">
                        Travel Information
                    </p>

                    <p className={"font-light mb-4"}>
                        Travel should be booked individually by each advisor via Concur using their OneID login details. Travel will be charged centrally. However, each individual will need to process the expense claim after the event in order to make sure your store is not charged for the travel. The charge code is 32764.
                        Communication and guidance is available on BootsLive.
                    </p>

                    {!working && (!data || data.length === 0) && (
                        <p className="text-center">
                            {translation('misc', 'no_items', {
                                item: translation('cms', 'venues')
                            })}
                        </p>
                    )}

                    {!working && data && data.map(this.renderVenue)}
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderVenue
     * @param {object} venue
     * @param {integer} key
     * @return {JSX.Element}
     */
    renderVenue(venue, key) {
        return (
            <div
                className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8"
                key={key}
            >
                <div>
                    <p className="text-2xl canela-text mb-4">
                        {getRecordValue(venue, 'name')}
                    </p>

                    <p className="font-bold">
                        Address
                    </p>

                    <p className="mb-4">
                        {getRecordValue(venue, 'address')}
                    </p>

                    <p className="mb-4 font-bold">
                        <a
                            href={getRecordValue(venue, 'website')}
                            target="_blank"
                            className="hover:underline"
                        >
                            Website
                        </a>
                    </p>

                    <p className="font-bold">
                        Conference Space
                    </p>

                    <p className="mb-4">
                        {getRecordValue(venue, 'conference_space')}
                    </p>

                    <details className="mb-4">
                        <summary>
                            <span className="font-bold cursor-pointer">
                                Travel Details - Car
                            </span>
                        </summary>

                        <p className="mt-2">
                            <RenderWYSIWYG
                                content={getRecordValue(venue, 'travel_car')}
                            />
                        </p>
                    </details>

                    <details className="mb-4">
                        <summary>
                            <span className="font-bold cursor-pointer">
                                Travel Details - Train
                            </span>
                        </summary>

                        <p className="mt-2">
                            <RenderWYSIWYG
                                content={getRecordValue(venue, 'travel_train')}
                            />
                        </p>
                    </details>

                    <details className="mb-4">
                        <summary>
                            <span className="font-bold cursor-pointer">
                                Travel Details - Airport
                            </span>
                        </summary>

                        <p className="mt-2">
                            <RenderWYSIWYG
                                content={getRecordValue(venue, 'travel_airport')}
                            />
                        </p>
                    </details>
                </div>

                <div>
                    <img
                        src={getRecordValue(venue, 'image', 'file')}
                        className="h-[32rem] mx-auto"
                    />
                </div>
            </div>
        );
    }
}
